const DashboardHeader = ({ label, className, children }) => {
  return (
    <div className={`${className}`}>
      <h2 className="text-lg md:text-xl font-semibold">{label}</h2>
      {children}
    </div>
  );
};

export default DashboardHeader;